import React, { Component } from "react";
import { fetchStudentProfileAction } from "../../actions/studentProfileAction";
import { connect } from "react-redux";
import { PacmanLoader } from "react-spinners";
import {
  CardDeck,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Row
} from "reactstrap";
import StudentSchool from "../../components/Student/StudentSchool";

class StudentProfile extends Component {
  componentDidMount() {
    this.props.dispatch(fetchStudentProfileAction());
  }

  render() {
    const { result } = this.props;

    if (result.loading === true) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    let schoolList;

    if (result.student.classes.length) {
      schoolList = result.student.classes.map(schoolclass => (
        <StudentSchool school={schoolclass} key={schoolclass.schoolId} />
      ));
    }
    return (
      <div className="animated fadeIn">
        <Card>
          <CardBody>
            <CardTitle>{result.student.name}</CardTitle>
            <CardSubtitle>
              <i className="fa fa-envelope" />
              &nbsp;&nbsp;
              {result.student.email}
            </CardSubtitle>

            <Row style={{ marginTop: "10px" }}>
              <CardDeck>{schoolList}</CardDeck>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    result: store.studentProfileReducer
  };
};

export default connect(mapStateToProps)(StudentProfile);
